import { graphql } from "../../gql";


export const masqueradeUsersQuery = graphql(`#graphql
	query MasqueradeCompanies {
		userProfilesPaginated(page: { number: 0, size: 9999999 }) {
			userProfiles {
				id
				firstName
				lastName
				company {
					id
					name
				}
			}
		}
	}
`);
